var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBtnForward = function SvgBtnForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5h5.6l-2.5 2.4c-.1.2-.1.6 0 .8h.7l3.3-3.3c.2-.2.2-.6 0-.8l-3.2-3.2a.566.566 0 10-.8.8l2.5 2.4H8.5c-.3 0-.5.2-.5.5s.2.5.5.5z"
  })));
};
export default SvgBtnForward;